// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ZoomableContext_overlay__2ZI4B","image":"ZoomableContext_image__3_EJO","infoButton":"ZoomableContext_infoButton__Pq8LY","info":"ZoomableContext_info__3-PQ7"};